import supabase from '../../supabase-client'; // Ajusta la ruta si es necesario

// Servicio de administración para Librería Lithay
export class AdminService {
  
  // Autenticar administrador
  static async authenticateAdmin(email, password) {
    try {
      console.log('🔍 LOGIN ATTEMPT:', {
        email,
        passwordLength: password.length,
        timestamp: new Date().toISOString()
      });

      const { data, error } = await supabase
        .from('dataadmin')
        .select('id_admin, email_admin, name_admin')
        .eq('email_admin', email)
        .eq('password_admin', password) // ⚠️ Reemplazar por bcrypt en producción
        .single();

      console.log('📊 SUPABASE RESPONSE:', {
        hasData: !!data,
        hasError: !!error,
        error: error ? error.message : null,
        dataFields: data ? Object.keys(data) : null
      });

      if (error) {
        console.error('❌ Authentication error:', error);
        return { success: false, error: 'Error de autenticación' };
      }

      if (data) {
        console.log('✅ LOGIN SUCCESSFUL for:', data.email_admin);
        return {
          success: true,
          admin: {
            id: data.id_admin,
            email: data.email_admin,
            name: data.name_admin
          }
        };
      } else {
        console.log('⚠️ LOGIN FAILED: No data returned');
        return { success: false, error: 'Credenciales incorrectas' };
      }
    } catch (error) {
      console.error('❌ Admin authentication error:', error);
      return { success: false, error: 'Error de conexión' };
    }
  }

  // Actualizar contraseña del administrador
  static async updateAdminPassword(adminId, newPassword) {
    try {
      const { data, error } = await supabase
        .from('dataadmin')
        .update({ password_admin: newPassword }) // ⚠️ Hashear antes de guardar
        .eq('id_admin', adminId)
        .select('id_admin, email_admin')
        .single();

      if (error) {
        console.error('Password update error:', error);
        return { success: false, error: 'Error al actualizar la contraseña' };
      }

      return { success: true, admin: data };
    } catch (error) {
      console.error('Admin password update error:', error);
      return { success: false, error: 'Error de conexión' };
    }
  }

  // Obtener información del administrador
  static async getAdminInfo(adminId) {
    try {
      const { data, error } = await supabase
        .from('dataadmin')
        .select('id_admin, email_admin, name_admin')
        .eq('id_admin', adminId)
        .single();

      if (error) {
        console.error('Get admin info error:', error);
        return { success: false, error: 'Error al obtener información del administrador' };
      }

      return { success: true, admin: data };
    } catch (error) {
      console.error('Get admin info error:', error);
      return { success: false, error: 'Error de conexión' };
    }
  }

  // Verificar si el administrador está autenticado
  static isAuthenticated() {
    const userType = localStorage.getItem('userType');
    const adminId = localStorage.getItem('adminId');
    return userType === 'admin' && !!adminId;
  }

  // Obtener datos del administrador actual desde localStorage
  static getCurrentAdmin() {
    if (!this.isAuthenticated()) {
      return null;
    }

    return {
      id: localStorage.getItem('adminId'),
      email: localStorage.getItem('adminEmail'),
      userName: localStorage.getItem('userName')
    };
  }

  // Cerrar sesión del administrador
  static logout() {
    localStorage.removeItem('userType');
    localStorage.removeItem('userName');
    localStorage.removeItem('adminId');
    localStorage.removeItem('adminEmail');
  }

  // Validar sesión activa
  static async validateSession() {
    const admin = this.getCurrentAdmin();
    if (!admin) {
      return { valid: false };
    }

    console.log(`🧭 Validando sesión para: ${admin.userName} (${admin.email})`);

    try {
      const result = await this.getAdminInfo(admin.id);
      return {
        valid: result.success,
        admin: result.success ? result.admin : null
      };
    } catch (error) {
      console.error('Session validation error:', error);
      return { valid: false };
    }
  }
}

export default AdminService;
